import React from "react";

import { useLocation, useNavigate } from "react-router-dom";
function GinaAlert(props) {
  const navigate = useNavigate();
  function onClickHandler() {
    props.minimize();
    navigate(props.url);
  }
  return (
    <>
      <div>{props.children}</div>
      {props.url && (
        <div
          style={{ textAlign: "center", marginTop: "5px" }}
          onClick={onClickHandler}
        >
          <div className="btn-glow">View Detail</div>
        </div>
      )}
    </>
  );
}

export default GinaAlert;
